function Loading() {
  return <p>...loading<span>🚀🍪</span></p>
}

export default Loading